<template>
  <div>
    <!-- 顶部面包屑 -->
    <breadcrumbs></breadcrumbs>

    <!-- 头部搜索表单 -->
    <div class="header-form">
      <el-form :inline="true" ref="form" :model="form" label-width="80px">
        <el-form-item label="代理商编号">
          <el-input
            v-model="form.name"
            placeholder="请输入代理商编号"
          ></el-input>
        </el-form-item>
        <el-form-item label="代理商姓名">
          <el-input
            v-model="form.name"
            placeholder="请输入代理商姓名"
          ></el-input> </el-form-item
        ><el-form-item label="代理商手机号">
          <el-input
            v-model="form.name"
            placeholder="请输入代理商手机号"
          ></el-input>
        </el-form-item>
      </el-form>
      <el-form :inline="true" ref="form" :model="form" label-width="80px">
        <span class="mgr-12 mgl-30">注册时间</span>
        <el-date-picker
          v-model="form.date"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          size="small"
        >
        </el-date-picker>
        <el-form-item class="mgl-100">
          <el-button type="primary">查询</el-button>
          <el-button @click="form = {}">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 合计与导出 -->
    <div class="flex aic jcsb color052154 fw-600">
      <div>合计代理商（名）：999</div>
      <el-button>导出</el-button>
    </div>
    <el-button type="primary" class="mgt-10 mgb-20" @click="addVisible = true"
      >新增代理</el-button
    >
    <!-- 表格 -->
    <el-table :data="tableData" border stripe style="width: 100%">
      <el-table-column
        type="index"
        :index="indexMethod"
        label="序号"
        width="80"
        fixed="left"
      >
      </el-table-column>
      <el-table-column prop="date" label="代理商编号" width="150">
      </el-table-column>
      <el-table-column prop="name" label="代理商姓名" width="150">
      </el-table-column>
      <el-table-column prop="province" label="代理商手机号" width="150">
      </el-table-column>
      <el-table-column prop="province" label="分润比例" width="150">
      </el-table-column>
      <el-table-column prop="zip" label="总设备数（台）" width="150">
      </el-table-column>
      <el-table-column prop="zip" label="总订单数（笔）" width="150">
      </el-table-column>
      <el-table-column prop="zip" label="总收益（元）" width="150">
      </el-table-column>
      <el-table-column prop="zip" label="已提现收益（元）" width="150">
      </el-table-column>
      <el-table-column prop="city" label="注册时间" width="150">
      </el-table-column>
      <el-table-column prop="address" label="账号状态"> </el-table-column>
      <el-table-column fixed="right" label="操作" width="100">
        <template slot-scope="scope">
          <el-button @click="handleClick(scope.row)" type="text" size="small"
            >详情</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页器 -->
    <el-pagination
      class="mgt-20"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-sizes="[5, 20, 30, 40, 50]"
      :page-size="pageSize"
      layout=" prev, pager, next"
      :total="total"
    >
    </el-pagination>

    <!-- 新增代理弹出层 -->
    <el-dialog
      :close-on-click-modal="modalFase"
      center
      title="新增代理"
      :visible.sync="addVisible"
      width="30%"
    >
      <el-form ref="addForm" :rules="rules" :model="addForm" label-width="80px">
        <el-form-item label="代理商姓名" prop="name">
          <el-input
            v-model="addForm.name"
            placeholder="请输入代理商姓名"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="所属企业" prop="enterprise">
          <el-input
            v-model="addForm.enterprise"
            placeholder="请输入企业名称"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input
            v-model="addForm.phone"
            placeholder="请输入代理商手机号"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="性别" prop="sex">
          <el-select v-model="addForm.sex" placeholder="请选择代理商性别">
            <el-option label="男" value="shanghai"></el-option>
            <el-option label="女" value="beijing"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input
            v-model="addForm.email"
            placeholder="请输入邮箱"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="职务" prop="job">
          <el-input
            v-model="addForm.job"
            placeholder="请输入职务"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="合作模式" prop="pattern">
          <el-radio-group v-model="addForm.pattern">
            <el-radio label="设备租赁"></el-radio>
            <el-radio label="设备购买"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          v-show="addForm.pattern == '设备租赁'"
          label="分润比例"
          prop="radio"
        >
          <el-input
            v-model="addForm.ratio"
            placeholder="请输入租赁分润比例"
            clearable
          ></el-input
          >%
        </el-form-item>
        <el-form-item label="备注" prop="desc">
          <el-input type="textarea" v-model="addForm.desc" clearable></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="mgr-50" @click="addVisible = false">取 消</el-button>
        <el-button type="primary" @click="applyAdd('addForm')">申 请</el-button>
      </span>
    </el-dialog>

    <!-- 新增代理操作提示 -->
    <el-dialog
      :close-on-click-modal="modalFase"
      center
      title="操作提示"
      :visible.sync="hintVisible"
      width="30%"
    >
      <span class="f20 fw-600 mgl-80"
        >新增代理申请已提交，平台审核通过后可下发设备。</span
      >
      <span slot="footer" class="dialog-footer">
        <el-button @click="hintVisible = false">已 知 晓</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";

export default {
  components: {
    breadcrumbs,
  },
  data() {
    return {
      modalFase: false,
      form: {}, //头部表单查询
      tableData: [
        {
          date: "2016-05-02",
          name: "王小虎",
          province: "上海",
          city: "普陀区",
          address: "上海市普陀区金沙江路 1518 弄",
          zip: 200333,
        },
      ],
      // 分页数据
      page: 1, // 当前页，默认
      pageSize: 5, //每页显示多少条数据，默认
      total: 50, // 数据总条数
      addVisible: false, //新增代理弹框是否打开
      addForm: {
        name: "",
        enterprise: "",
        phone: "",
        sex: "",
        email: "",
        job: "",
        pattern: "",
        ratio: "",
        desc: "",
      }, //新增代理商数据
      rules: {
        name: [
          { required: true, message: "请输入代理商姓名", trigger: "blur" },
        ],
        enterprise: [
          { required: true, message: "请输入企业名称", trigger: "blur" },
        ],
        phone: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur",
          },
        ],
        sex: [
          {
            required: true,
            message: "请选择性别",
            trigger: "blur",
          },
        ],
        email: [
          {
            required: true,
            message: "请输入正确的电子邮箱",
            trigger: "blur",
          },
        ],
        job: [{ required: true, message: "请输入职务", trigger: "blur" }],
        ratio: [{ required: true, message: "请填写分润比例", trigger: "blur" }],
        pattern: [
          { required: true, message: "请选择合作模式", trigger: "blur" },
        ],
      }, //新增代理表单验证规则
      hintVisible: false, //新增代理提示弹框是否打开
    };
  },
  methods: {
    //表格序号，根据索引+1
    indexMethod(index) {
      return index + 1;
    },
    // 表格点击详情跳转到详情页面
    handleClick(row) {
      console.log(row);
      this.$router.push("/agentmanagement/agent_lists/details_details");
    },
    // 分页事件
    // 每页显示多少条,条数改变时触发事件
    handleSizeChange(val) {
      console.log(val);
    },
    // 当前页面,当前页面改变时触发事件
    handleCurrentChange(val) {
      console.log(val);
    },
    // 新增代理商弹框申请按钮点击事件
    applyAdd(addForm) {
      this.$refs[addForm].validate((valid) => {
        if (valid) {
          this.hintVisible = true;
          this.addForm = {};
        } else {
          console.log("error submit!!");
          return false;
        }
      });
      // this.hintVisible = true;
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-form-item__label {
  width: 100px !important;
}
.el-date-editor,
.el-input {
  width: 250px;
}
// table表格标题
/deep/ .el-table__header .cell {
  color: var(--text-main) !important;
  font-weight: 600 !important;
}
.el-select,
.el-textarea {
  width: 250px;
}
.el-dialog {
  .el-form {
    margin-left: 50%;
    transform: translateX(-50%);
    /deep/ .el-form-item__content {
      display: flex !important;
    }
  }
}
</style>
